/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export const ConflictLevelsStatusEnum = {
    Resolved: 'Resolved',
    ContactOtherClaimant: 'Contact other claimant',
    AssistedResolutionProcessPhase1: 'Assisted Resolution Process: Phase 1',
    AssistedResolutionProcessPhase2: 'Assisted Resolution Process: Phase 2',
    AssistedResolutionProcessPhase3: 'Assisted Resolution Process: Phase 3',
    ErpPresumptionInYourFavour: 'ERP: Presumption in Your Favour',
    ErpPresumptionInFavourOfTheOtherParty: 'ERP: Presumption in Favour of the Other Party',
    ErpPresumptionSuccessfullyChallengedByOtherParty: 'ERP: Presumption Successfully Challenged by Other Party',
    ErpPresumptionSuccessfullyChallenged: 'ERP: Presumption Successfully Challenged',
    InternalDetermination: 'Internal Determination',
    AssistedResolutionProcessPhase4Final: 'Assisted Resolution Process: Phase 4 (Final)',
};
